module.exports = __webpack_public_path__ + "static/img/logoTitle.5a1776f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoTitle.png
// module id = ImO/
// module chunks = 1